"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWasteManagement = function IconWasteManagement(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21.503 5.1a5 5 0 0 0-6.87.194l-9.522 9.57-.182.192a5 5 0 0 0 .184 6.882l.003.002.144.144-.886.886H.18a24 24 0 0 0 0 2h5.024L6.675 23.5l15.781 15.772a5.502 5.502 0 0 0 8.933 6.087 5.48 5.48 0 0 0 1.61-3.943l9.708-9.708.147-.156c1.694-1.882.898-4.229-1.305-6.446L21.75 5.305l-.015.016zm-1.182 1.634-.029-.027a3 3 0 0 0-4.099-.137l-.144.135-9.522 9.573a3 3 0 0 0-.136 4.1l.136.145.003.003zm3.29 30.846-.01.008L8.09 22.085 21.895 8.28l18.238 18.237.172.177c1.446 1.519 1.808 2.768.983 3.604l-8.816 8.816a5.5 5.5 0 0 0-8.861-1.535m6.363 1.414a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95m-3.535 1.414a1.5 1.5 0 1 0 2.121 2.121 1.5 1.5 0 0 0-2.121-2.121m.707.707a.5.5 0 1 1 .707.707.5.5 0 0 1-.707-.707m2.717-19.888 7.78 7.78-.707.707-7.78-7.78z",
    clipRule: "evenodd"
  })));
};

export { IconWasteManagement, IconWasteManagement as default };
